import { createFileRoute } from "@tanstack/react-router";
import { GroupsPage } from "@corpuscomplete/web/modules/auth/group/pages/groups";
import { queries } from "@corpuscomplete/core/zero";

export const Route = createFileRoute("/_authenticated/groups/")({
  component: GroupsPage,
  loader: async ({ context }) => {
    void context.zero?.run(queries.space.byMembership());
  },
});
